<template>
    <div class="w-full h-full">
        <FormModal
            v-if="showFilters"
            @cancel="showFilters=false ; offerType = []; retailerCategory = undefined"
            @confirm="showFilters=false; getSupportTickets(0,25)"
            :valid="true"
            title="Filter results"
            subtitle="Select from these filters to refine your search"
            submitButtonText="Apply filters"
        >
            <div class="grid gap-3">
                <CustomCheckbox v-model="offerType" :options="supportLevel" label="Select support level:"/>
                <CustomSelect v-model="orderBy" :pre-select="orderBy" :options="orderByList" label="Resolved"/>
            </div>  
        </FormModal>
        <Header
            title="End user support"
            icon="HandHelping"
        />
        <WhiteBox
            title="Support tickets"
            subText="View support tickets from your end users"
        >
        <template v-slot:buttons>
            <CustomButton small id="filterButton" text="Filter results" icon="Filter" type="action"
                @click="showFilters = true" />
        </template>

            <template v-slot:content>
                <div v-if="offerType && offerType.length > 0 " class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Applied support levels:</p>
                    <div  class="flex justify-start items-center py-1 gap-1">
                        <div v-for="offer,index in offerType" :key="index">
                            <StatusPill :text="offer.id" colour="gray" />

                    </div>
     
                        <div class="flex items-center gap-1 px-1 py-0.5 bg-white border border-white w-min"
                        >

                        <p class="text-xs font-medium text-nowrap text-blue-600 underline hover:font-semibold cursor-pointer" @click="offerType = []; orderBy = false; getSupportTickets(0,25)">Clear filters</p>
                        </div>
                    </div>
                </div>
                <div class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Displaying:</p>
                    <div  class="flex justify-start items-center py-1 gap-1">
         
     
                        <div class="flex items-center gap-1 px-3 py-0.5 bg-gray-100 rounded-full border border-gray-400 w-min"
                        >
                        <p v-if="orderBy" class="text-xs font-medium text-nowrap">Closed tickets</p>
                        <p v-else class="text-xs font-medium text-nowrap">Open tickets</p>

                        </div>
                        
                        <div class="flex items-center gap-1 px-1 py-0.5 bg-white border border-white w-min"
                        >
                        </div>
                    </div>
                </div>

                <div class="grid mt-6">
                    <SearchBar placeholderText="Search by end user id" @search="(val) => getSupportTicketsByUserId(0,25,val)">
                        <CustomButton small text="" type="default" icon="X" @click="getSupportTickets(0,25)" />
                    </SearchBar>
                </div>
                <EasyDataTable
                    :headers="headersTable1"
                    :items="retailers"
                    :loading="loading"
                    v-model:server-options="serverOptions"
                    :server-items-length="serverItemsLength"
                    :hide-footer="false"
                    :no-hover="true"
                >
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                    <div class="flex justify-center py-4">
                        <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                            <p class="text-sm mr-2">No results</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                            </svg>
                        </div>
                    </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    
                    <template #item-createdOn="ticket">
                        {{ niceDateTime(ticket.createdOn) }}
                    </template>

                    <template #item-updatedOn="ticket">
                        <div v-if="ticket.updatedOn != null">{{ niceDateTime(ticket.updatedOn) }}</div>
                    </template>
                    <!-- <template #item-offerRequested="retailers">
                        <div class="flex justify-start items-center py-1 gap-1">
                            {{retailers.programOffers.length}}/{{retailers.offersList.length }}
                        </div>
                    </template>
                    <template #item-offerApproved="retailers">
                        <div class="flex justify-start items-center py-1 gap-1">
                           {{retailers.programOffers.filter(offer => offer.offerApproval == "APPROVED").length }}/ {{retailers.offersList.length }}
                        </div>
                    </template> -->

                    <template #item-action="ticket">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton small text="View ticket" type="navigate" @click="$router.push(`/support/${ticket.id}`)" />
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import SearchBar from '@/components/SearchBar.vue'
import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import FormModal from "@/components/modals/FormModal.vue";
import CustomCheckbox from "@/components/inputs/CustomCheckbox.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";
import StatusPill from "@/components/StatusPill.vue";
import { DateTime } from 'luxon';


export default {
	name: "manage-publsihers",
	components: {
        Header,
        WhiteBox,
		CustomButton,
        CustomCheckbox,
        CustomSelect,
        SearchBar,
        StatusPill,
        FormModal
	},
	props:{
    },

	data() {
		return {
            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,
            showFilters: false,
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,


            selectedRetailer: undefined,
            loading:true,
            headersTable1:[
                { text: "Ticket Id", value: "id" },
                { text: "Resolved", value: "resolved"},                
                { text: "End user Id", value: "endUserId"},
                { text: "Transaction Id", value: "transactionId"},
                { text: "Expected offer Id", value: "programOfferRequested.id"},
                
                { text: "Created On", value: "createdOn"},
                { text: "Updated On", value: "updatedOn"},
                { text: "Action", value: "action"},
            ],
            retailers:[

            ],
            orderByList:[
            { "id": true, "text": "Resolved tasks" },
            { "id": false, "text": "Unresolved tasks" },
],
            supportLevel:[
                { id: "CLIENT", text: 'CLIENT' }, 
                { id: "BOOGI", text: 'BOOGI' },
                { id: "SUPPLIER", text: 'SUPPLIER' },
                
            ],
            activeFilters:[
                { id: "CLIENT", filter: true }, 
                { id: "BOOGI", filter: true },
                { id: "SUPPLIER", filter: true },
               
            ],
            offerType: [
            { id: "CLIENT", text: 'CLIENT' }
            ],
            orderBy: false,
        }
	},
	created(){
        this.getSupportTickets(0,25)


	},
	methods: {

        niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
		},

        async getSupportTicketsByUserId(page,size,userId){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')


                if(this.offerType.length > 0)
                {var offerType = []
                this.offerType.forEach(element => {
                    offerType.push(element.id)
                });
            }
                this.loading = true
                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/support/user/${userId}?page=${page}&size=${size}&resolved=${this.orderBy}${this.offerType.length > 0  ? '&supportLevel='+offerType : '' }`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `${token}`,
                        },
                    });

				if (response.ok) {
					var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.retailers = object.content  

                    this.loading = false
				}
				
			} catch (error) {
				return;
			}

		},

        async getSupportTickets(page,size){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')


                if(this.offerType.length > 0)
                {var offerType = []
                this.offerType.forEach(element => {
                    offerType.push(element.id)
                });
            }
                this.loading = true
                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/support?page=${page}&size=${size}&resolved=${this.orderBy}${this.offerType.length > 0  ? '&supportLevel='+offerType : '' }`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `${token}`,
                        },
                    });

				if (response.ok) {
					var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.retailers = object.content  

                    this.loading = false
				}
				
			} catch (error) {
				return;
			}

		},

	},
	computed: {

	},
    mounted() {
        document.title = "Dashboard | Support tickets";
    },
	watch: {
        serverOptions: {
            deep: true,
            handler(val){
                     this.getSupportTickets(val.page-1,val.rowsPerPage)
                }
    },
	}
}
</script>